import { Stack } from "@mantine/core";
import Issuance from "../../../pages/Issuance/Issuance";
import GetYourQuoteBooking from "../../../../sales/forms/GetYourQuoteBooking/GetYourQuoteBooking";
import classes from "./SingleIssuanceWizard.module.css";

const StepOne = ({
  issueAs,
  onIssueAsChange,
  selectedOperator,
  setSelectedOperator,
  onOperatorMeta,
  onUrlReady,
  onTripPreview,
}) => {
  const canQuote = issueAs === "User" || (issueAs === "Operator" && selectedOperator);

  return (
    <Stack gap="sm">
      <div className={classes.embeddedSection}>
        <Issuance
          embedded
          selectedValue={issueAs}
          onChange={onIssueAsChange}
          policyType="single"
          setSelectedCover={() => {}}
          selectedOperator={selectedOperator}
          setSelectedOperator={setSelectedOperator}
          onOperatorMeta={onOperatorMeta}
        />
      </div>

      {canQuote && (
        <GetYourQuoteBooking
          embedded
          coverFilterMode
          issueAs={issueAs}
          onUrlReady={onUrlReady}
          onTripPreview={onTripPreview}
          selectedOperator={selectedOperator}
        />
      )}
    </Stack>
  );
};

export default StepOne;
